import request from '@/utils/request'


//查询列表
export function bannerList(data) {
  return request({
    url: '/admin/storeBanner/list',
    method: 'post',
    data:data
  })
}

//添加轮训图
export function bannerAdd(data) {
  return request({
    url: '/admin/storeBanner/add',
    method: 'post',
    data:data
  })
}

//删除
export function bannerDeleteById(params) {
  return request({
    url: '/admin/storeBanner/deleteById',
    method: 'get',
    params: params
  })
}





// WEBPACK FOOTER //
// ./src/api/storeFrontBanner.js